(function() {
  
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
  };
  
  var variant = getUrlParameter('variant');
  var index = 0;
  
  console.log(variant);
  
  if(variant === '29440148340835'|| variant === '29523887095907' || variant === '29523925106787' || variant === '29523931627619') {
    index = 0;
  }
  
  else if(variant === '29440148373603' || variant === '29523903742051' || variant === '29523925139555' || variant === '29523931660387'){
    index = 1;
    jQuery('.send-owl-variant').addClass('hide');
    jQuery('.send-owl-link').children('.send-owl-variant').eq(index).removeClass('hide');
  }
  
  else if(variant === '29440148406371') {
    index = 2;
    jQuery('.send-owl-variant').addClass('hide');
    jQuery('.send-owl-link').children('.send-owl-variant').eq(index).removeClass('hide');
  }
  
  function swatchesLoaded() {
  
    // Switch Subscribe Send Owl Button on
    jQuery('.swatch-content .swatch-element').click(function() {
      index = jQuery(this).index();
      jQuery('.send-owl-variant').addClass('hide');
      jQuery('.send-owl-link').children('.send-owl-variant').eq(index).removeClass('hide');
    });
    
  }
  
  var checkExist = setInterval(function() {
     if (jQuery('.swatch-content .swatch-element').length > 1) {
        swatchesLoaded();
        clearInterval(checkExist);
     }
  }, 100);
})(jQuery);